// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const playerValidationErrors = {
  role: {
    required: 'Oyuncu rolü alanı girilmesi zorunludur',
  },
  notification: {
    titleRequired: 'Başlık alanı zorunludur',
    titleMax: 'Başlık en fazla 200 karakter olabilir',
    messageRequired: 'Mesaj alanı zorunludur',
    messageMax: 'Mesaj en fazla 2000 karakter olabilir',
  },
}

const { role, notification } = playerValidationErrors

export const playerSearchSchema = adminListSearchSchema

export const editPlayerSchema = z.object({
  role_ids: z.array(z.string().uuid()).min(1, role.required),
})

export const sendPlayerNotificationSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, notification.titleRequired)
    .max(200, notification.titleMax),
  message: z
    .string()
    .trim()
    .min(1, notification.messageRequired)
    .max(2000, notification.messageMax),
})
